import React, { useContext, useEffect, useState } from "react";
import feesService from "../../services/fees/feesService";
import { EventContext } from "../../context/Event/eventContext";
import { L } from "../../lib/abpUtility";

let abp = window.abp;

export const PricingTable = () => {
  const [fees, setFees] = useState();
  const { lastEvent } = useContext(EventContext);

  const formatFeeAmount = (feeName) => {
    const fee = fees?.find((o) => o?.name === feeName);

    if (!fee) {
      return "";
    }

    return `€${fee.amount} / ${fee.legacyAmount} лв.`;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    feesService.getFees().then((resFees) => {
      let idx = resFees.findIndex(function (element) {
        return element.name === "Discount";
      });

      delete resFees[idx];

      setFees(resFees);
    });
  }, [lastEvent]);

  return (
    <div>
      {((fees && lastEvent?.eventState?.value === 2) ||
        abp.auth.hasPermission("Pages.Payments.Pay")) && (
        <table className="tg">
          <thead>
            <tr>
              <th className="tg-i7og" colSpan="6">
                <h4 className="mb-1">{L("FeeAmounts")} *</h4>
              </th>
            </tr>
            <tr th className="tg-i7og" colSpan="6"></tr>
            <tr>
              <th className="tg-i7og" rowSpan="2">
                {L("Age")}
              </th>
              <th className="tg-i7og" colSpan="2">
                {L("FullProgram") + " (" + L("wholeCamp") + ")**"}
              </th>
              <th className="tg-i7og" colSpan="2">
                {L("AllEvenings")}
              </th>
              <th className="tg-i7og">{L("TentPerPerson")}</th>
            </tr>
            <tr>
              <th className="tg-9ji8">{L("single")}</th>
              <th className="tg-9ji8">{L("inGroup")}</th>
              <th className="tg-9ji8">{L("perEvening")}</th>
              <th className="tg-9ji8">{L("allEveningsLC")}</th>
              <th className="tg-9ji8">
                {L("perNight")}/{L("perPerson")}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="tg-xw33">{L("upTo8Years")}</td>
              <td className="tg-i7og" colSpan="5">
                {L("Free")}
              </td>
            </tr>
            <tr>
              <td className="tg-xw33">{L("9to12years")}</td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp9To12")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp9To12Group")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceEvening9To12")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceAllEvenings9To12")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("AccommodationTent9Plus")}
              </td>
            </tr>

            <tr>
              <td className="tg-xw33">{L("13to17years")}</td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp13To17")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp13To17Group")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceEvening13To17")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceAllEvenings13To17")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("AccommodationTent9Plus")}
              </td>
            </tr>

            <tr>
              <td className="tg-xw33">{L("over18years")}</td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp18Plus")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceWholeCamp18PlusGroup")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceEvening18Plus")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("PresenceAllEvenings18Plus")}
              </td>
              <td className="tg-xw33">
                {formatFeeAmount("AccommodationTent9Plus")}
              </td>
            </tr>
            <tr>
              <td className="tg-i3ji" colSpan="7">
                {L("discountForFewerDays")}
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PricingTable;
